<template>
  <GravManagerWrapper :id="id" :componentName="componentName" :properties="props">
    <component :is="VisualTree" v-bind="{ style: $attrs.style, ...changableProps }">
      <template v-for="slotName in Object.keys($slots)" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </component>
  </GravManagerWrapper>
</template>

<script setup lang="ts">
import GravManagerWrapper from './GravManagerWrapper.vue';
import { VisualTreeProps } from './VisualTree.ts';
import VisualTree from './VisualTree.vue';

import { useChangableProps } from '@/composables/useChangableProps';

const componentName = 'ui-visual-tree';
const $slots = defineSlots<Record<string, unknown>>();

const props = defineProps<VisualTreeProps>();
const changableProps = useChangableProps(componentName, props);

</script>
